import { getSettings } from "./get-settings";

const DEFAULT_TIMEOUT = 10000;

export const plainFetcher = async (url: string, props?: any) => {
  const settings = await getSettings();

  const newProps = { ...props };
  newProps.headers = {
    "X-ASH-Authorization": window.localStorage.getItem("accessToken"),
    ...newProps.headers,
  };

  const response = await fetch((settings.apiEndpoint ?? "") + url, newProps);
  return handleErrors(response, url);
};

export const fetcher = async (url: string, props?: any) => {
  const response = await plainFetcher(url, props);
  return await response.json();
};

export const fetchWithTimeout = (
  url: string,
  timeout = DEFAULT_TIMEOUT,
  props?: any
) => {
  return Promise.race([
    fetcher(url, props),
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error("Timeout")), timeout);
    }),
  ]);
};

function handleErrors(response: Response, url: string) {
  if (!response.ok) {
    throw Error(
      `Http error when requesting ${url}: ${response.status}, ${response.statusText}`
    );
  }
  return response;
}
